export default "https://cdn-static.gokick.com/assets/a667d1dc3297954618d7ed7be4de1ad72d2b7ee9/images/one-pack.d480e98fa5cc774d464fa35a18a8809f.png";